import { IError, IMetaData } from './services';

export enum ETransactionPaymentStatuses {
  ANNULED = 'ANNULED',
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  IN_PROCESS = 'IN_PROCESS',
  PENDING = 'PENDING',
  REFUNDED = 'REFUNDED',
  PARTIAL_REFUND = 'PARTIAL_REFUND',
  REJECTED = 'REJECTED'
}

export const dictionaryTransactionStatus = {
  [ETransactionPaymentStatuses.ANNULED]: 'Anulada',
  [ETransactionPaymentStatuses.APPROVED]: 'Aprobada',
  [ETransactionPaymentStatuses.CANCELED]: 'Cancelada',
  [ETransactionPaymentStatuses.IN_PROCESS]: 'En Proceso',
  [ETransactionPaymentStatuses.REFUNDED]: 'Devuelto',
  [ETransactionPaymentStatuses.PARTIAL_REFUND]: 'Parcialmente Devuelto',
  [ETransactionPaymentStatuses.PENDING]: 'Pendiente',
  [ETransactionPaymentStatuses.REJECTED]: 'Rechazada'
};

export enum PaymentErrorCodes {
  PENDING_AUTHORIZATION = 'PENDING_AUTHORIZATION',
  INVALID_MERCHANT = 'INVALID_MERCHANT',
  DENIED = 'DENIED',
  DENIED_RETAIN_CARD = 'DENIED_RETAIN_CARD',
  TRANSACTION_ERROR = 'TRANSACTION_ERROR',
  INVALID_AMOUNT = 'INVALID_AMOUNT',
  INVALID_CARD = 'INVALID_CARD',
  SECURITY_CODE_ERROR = 'SECURITY_CODE_ERROR',
  DENIED_UNAVAILABLE_INSTALLMENTS = 'DENIED_UNAVAILABLE_INSTALLMENTS',
  NOT_CURRENT_CARD = 'NOT_CURRENT_CARD',
  MAX_INSTALLMENTS_EXCEEDED = 'MAX_INSTALLMENTS_EXCEEDED',
  INVALID_CARD_EXPIRATION_DATE = 'INVALID_CARD_EXPIRATION_DATE',
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  INVALID_QR = 'INVALID_QR',
  EXPIRED_CARD = 'EXPIRED_CARD',
  DISABLED_CARD = 'DISABLED_CARD',
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
  DENIED_INVALID_INSTALLMENTS = 'DENIED_INVALID_INSTALLMENTS',
  DENIED_OFFLINE_ISSUER = 'DENIED_OFFLINE_ISSUER',
  QR_ALREADY_PROCESSED = 'QR_ALREADY_PROCESSED',
  DENIED_SYSTEM_ERROR = 'DENIED_SYSTEM_ERROR',
  PIN_ERROR = 'PIN_ERROR',
  NO_INSTALLMENTS = 'NO_INSTALLMENTS',
  PCT_REVERSE_PAYMENT = 'PCT_REVERSE_PAYMENT',
  PCT_PARTIAL_REFUND_PAYMENT = 'PCT_PARTIAL_REFUND_PAYMENT',
  TRANSACTION_EXPIRED = 'TRANSACTION_EXPIRED',
  PCT_DEBIT_ERROR = 'PCT_DEBIT_ERROR',
  PCT_CREDIT_ERROR = 'PCT_CREDIT_ERROR',
  RISKY = 'RISKY',
  MERCHANT_CANCELLATION = 'MERCHANT_CANCELLATION',
  INVALID_CARD_TRANSACTION_NOT_ALLOWED = 'INVALID_CARD_TRANSACTION_NOT_ALLOWED',
  INVALID_CARD_DECLINED = 'INVALID_CARD_DECLINED',
  INVALID_CARD_INCORRECT_MANUAL_ENTRY = 'INVALID_CARD_INCORRECT_MANUAL_ENTRY',
  INVALID_CARD_INVALID_SERVICE = 'INVALID_CARD_INVALID_SERVICE',
  INVALID_CARD_INVALID_NUMBER = 'INVALID_CARD_INVALID_NUMBER',
  INVALID_AUTHENTICATION_CREDENTIALS = 'INVALID_AUTHENTICATION_CREDENTIALS',
  REQUEST_AUTHORIZATION_CARD = 'REQUEST_AUTHORIZATION_CARD',
  INVALID_PARAM_PAYMENT_METHOD_ID = 'INVALID_PARAM_PAYMENT_METHOD_ID',
  YOU_CANNOT_CONSUME_THIS_SERVICE = 'YOU_CANNOT_CONSUME_THIS_SERVICE',
  BANK_UNAVAILABLE = 'BANK_UNAVAILABLE',
  ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
  GET_CBU_ACCOUNT_ERROR = 'GET_CBU_ACCOUNT_ERROR',
  INVALID_BUYER = 'INVALID_BUYER',
  INTEROPERABLE_SYSTEM_ERROR = 'INTEROPERABLE_SYSTEM_ERROR',
  ACQUIRER_DENIED = 'ACQUIRER_DENIED',
  ACQUIRER_ERROR = 'ACQUIRER_ERROR'
}

export enum PaymentMethodType {
  CARD = 'CARD',
  ACCOUNT = 'ACCOUNT'
}

export enum BrandType {
  AGRO = 'agro',
  AMEX = 'american_express',
  AUH_PROGRESAR = 'AUH / Progresar',
  BLACK = 'black',
  BUSINESS = 'business',
  CLASSIC = 'classic',
  COMMERCIAL_BUSINESS = 'commercial_business',
  CORPORATE = 'corporate',
  CORPORATE_GOLD = 'corporate gold',
  ELECTRON = 'electron',
  EXECUTIVE_BUSINESS = 'executive business',
  GOLD = 'gold',
  INTERNACIONAL = 'internacional',
  MAESTRO = 'maestro',
  NACIONAL = 'nacional',
  PLATINUM = 'platinum',
  PREPAID = 'prepaid',
  PREVIAJE = 'previaje',
  PURCHASING = 'purchasing',
  REGIONAL = 'regional',
  SANCOR = 'sancor',
  SIGNATURE = 'signature',
  SOCIAL = 'social',
  STANDARD = 'standard'
}

export interface PaymentPromosDto {
  title: string;
  payment_id: string;
  cashback_id: string;
  bank_id: string;
  status: string;
  status_detail: string;
  updated_at: Date;
}

export interface ITransactionsDataDetail {
  bank_name: string | undefined;
  card_brand: BrandType;
  card_issuer: string | undefined;
  card_type?: ECardType;
  last_digits: string | undefined;
  merchant_cuit: string;
  merchant_name: string;
  payment_amount: number;
  payment_date: string | undefined;
  payment_id: string;
  payment_status: ETransactionPaymentStatuses;
  promos?: PaymentPromosDto[];
  qr_acquirer_name: string | undefined;
  reference_code?: string;
  terminal_id: string | undefined;
  additional_info?: string;
  original_error_code?: string;
  operation_error?: string;
  installments_quantity?: string;
}

export interface ITransactionDetailResponse {
  error?: IError;
  data?: ITransactionsDataDetail;
  metadata?: IMetaData;
}

export enum ECardType {
  DEBIT = 'DEBIT',
  CREDIT = 'CREDIT',
  PCT = 'PCT'
}

/** PCT se muestra como la sigla: no tiene nombre propio en el portal. */
export const dictionaryCardType = {
  [ECardType.DEBIT]: 'Débito',
  [ECardType.CREDIT]: 'Crédito',
  [ECardType.PCT]: 'PCT'
};
export interface IExportTransactions {
  paymentDate: string;
  taxID: string;
  merchantName: string;
  amount: number;
  paymentStatus: 'Aprobada' | 'Devuelto' | 'Anulada';
  terminalID: string;
  acquirer: string;
  bank: string | null;
  cardBrand: string;
  cardIssuer: string;
  cardType: 'Crédito' | 'Débito';
  cardNumber: string;
  paymentID: string;
  refCode: string;
}

export interface Acquirer {
  name: string;
}

export interface Bank {
  name: string;
  image_url: string;
}

export interface Card {
  brand: BrandType;
  type: ECardType;
  last_digits: string;
  issuer: Bank;
}

export interface Merchant {
  name: string;
  cuit: string;
  address: string;
  image_url: string;
}

export interface Terminal {
  id: string;
}

export interface ITransactionsData {
  id: string;
  date: string;
  status: ETransactionPaymentStatuses;
  amount: number;
  reference_code: string;
  merchant: Merchant;
  terminal: Terminal;
  bank: Bank;
  card: Card;
  acquirer: Acquirer;
}

export interface ITransactionsResponse {
  error?: IError;
  data?: { transactions?: ITransactionsData[] };
  metadata?: IMetaData;
}

export interface ITransactionsSummary {
  total_payments: number;
  tpv_total: number;
  average_ticket: number | null;
  approval_rate: number;
  canceled_rate: number;
}

/**
 * Shape crudo de GET /v2/transactions/kpis. Difiere del modelo del portal en
 * nombres (avg_ticket, rejection_rate) y en unidades (montos en centavos,
 * tasas en porcentaje 0-100). La traduccion vive en el servicio.
 */
export interface IKpisApiResponse {
  total_payments: number;
  tpv_total: number;
  avg_ticket: number;
  approval_rate: number;
  rejection_rate: number;
}

export interface ITransactionsSummaryResponse {
  error?: IError;
  data?: ITransactionsSummary;
  metadata?: IMetaData;
}

export interface ITransactionsMetadata {
  card_types: string[];
  banks: string[];
  card_brands: string[];
  /** Opciones de estado; si backend no la envía, el frontend usa el enum local. */
  statuses?: string[];
  /** Sucursales; el filtro por sucursal quedó fuera del MVP y todavía nadie las consume. */
  branches?: { id: string; name: string }[];
}

export interface ITransactionsMetadataResponse {
  error?: IError;
  data?: ITransactionsMetadata;
  metadata?: IMetaData;
}

/** Criterios de la búsqueda exacta (H3). La ventana de ±10 min sobre datetime la resuelve el BFF. */
export interface ISearchTransactionsCriteria {
  datetime: string;
  amount: number;
  payment_method: string;
  bank?: string | null;
}
